import { DownloadOutlined } from '@ant-design/icons'
import { Button } from 'antd'
import React, { useState } from 'react'

export default function DownloadFile({ file }) {
  const [loading, setLoading] = useState(false)

  return (
    <div>
      <Button
        size="small"
        type="primary"
        loading={loading}
        onClick={async () => {
          setLoading(true)
          const response = await fetch(file.fileUrl)
          const blob = await response.blob()

          const objectUrl = URL.createObjectURL(blob)

          const a = document.createElement('a')
          a.href = objectUrl
          a.download = file.label
          a.click()

          URL.revokeObjectURL(objectUrl)
          setLoading(false)
        }}
        icon={<DownloadOutlined />}
        disabled={!file.fileUrl}
      />
    </div>
  )
}
